import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { assertMaintenanceAvailable, recognizeMaintenance } from './maintenance-state';

export const maintenanceInterceptor: HttpInterceptorFn = (request, next) => {
  assertMaintenanceAvailable();
  return next(request).pipe(catchError(error => {
    recognizeMaintenance(error.status, error.error);
    return throwError(() => error);
  }));
};
